export const goodsTabTypeOptions = [
  {
    id: 1,
    title: '外部商品',
  },
  {
    id: 2,
    title: '内部积分商品',
  },
]

export const goodsTypeOptions = [
  {
    id: 1,
    title: '外部商城商品',
  },
  {
    id: 2,
    title: '外部商城会员卡',
  },
  {
    id: 3,
    title: '内部积分商城',
  },
]

export const goodsIsHotOptions = [
  {
    id: 0,
    title: '否',
  },
  {
    id: 1,
    title: '是',
  },
]

export function getTitleById(list, id) {
  const item = list.find((s) => s.id == id)
  if (item) {
    return item.title
  } else {
    return ''
  }
}
